import { render, staticRenderFns } from "./CounselorIncentive.vue?vue&type=template&id=cbf8f806&scoped=true"
import script from "./CounselorIncentive.vue?vue&type=script&lang=js"
export * from "./CounselorIncentive.vue?vue&type=script&lang=js"
import style0 from "./CounselorIncentive.vue?vue&type=style&index=0&id=cbf8f806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf8f806",
  null
  
)

export default component.exports